import { render, staticRenderFns } from "./RoleGenderGraph.vue?vue&type=template&id=2368e988&"
import script from "./RoleGenderGraph.vue?vue&type=script&lang=ts&"
export * from "./RoleGenderGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports